(function () {
	const loadMore = document.getElementById('load-more');

	if (!loadMore) return;

	// Check if load_more_data is available
	if (typeof load_more_data === 'undefined') {
		console.error('load_more_data is not defined');
		return;
	}

	let paged = 1; // Use number instead of string
	const maxPages = parseInt(loadMore.getAttribute('data-max-pages'), 10) || 1;
	const postType = loadMore.getAttribute('data-post-type');
	const category = loadMore.getAttribute('data-category') || '';
	const author = loadMore.getAttribute('data-author') || '';
	const vertical = loadMore.getAttribute('data-vertical') || '';

	loadMore.addEventListener('click', function (event) {
		event.preventDefault();

		// Prevent multiple simultaneous requests
		if (loadMore.disabled) return;

		loadMore.disabled = true;

		fetch(load_more_data.url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams({
				nonce: load_more_data.nonce,
				locale: load_more_data.locale,
				paged: paged.toString(),
				postType: postType,
				category: category,
				author: author,
				vertical: vertical,
				action: 'more_posts',
			}),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				return response.text();
			})
			.then((response) => {
				const container = document.getElementById('article-list-archive');
				if (!container) {
					loadMore.disabled = false;
					return;
				}

				container.insertAdjacentHTML('beforeend', response);
				paged++;

				// Use strict comparison and proper conditional
				if (paged >= maxPages) {
					loadMore.remove();
				} else {
					loadMore.disabled = false;
				}
			})
			.catch((error) => {
				console.error('Error:', error);
				loadMore.disabled = false;
			});
	});
})();
